import isObject from '#shared/util/isObject.js';
import appError from '#shared/util/appError.js';
import appDebug from '#shared/util/appDebug.js';
import readArguments from '#shared/util/readArguments.js';
import logger from '#shared/util/logger.js';

/**
 * window.app polyfill
 */
if (!isObject(window.app)) {
	window.app = {};
}

/**
 * window.app.asyncCall polyfill
 * @param {string} method
 * @param {Function} callback
 * @param {Array|object} [parameters]
 */
if (typeof window.app.asyncCall !== 'function') {
	window.app.asyncCall = (method, callback, parameters) => {
		if (typeof method === 'string' && typeof callback === 'function' && (typeof parameters === 'undefined' || typeof parameters === 'object' && parameters)) {
			const globalMethod = window[method];
			if (typeof globalMethod === 'function') {
				setTimeout(() => {
					const parametersArray = Array.isArray(parameters) ? parameters : [parameters];
					const response = globalMethod(...parametersArray);
					let responseArray;
					if (typeof response === 'undefined') {
						responseArray = [];
					} else if (Array.isArray(response)) {
						responseArray = response;
					} else {
						responseArray = [response];
					}
					appDebug(`asyncCall ${method}`, {
						code: 'CLIENT',
						origin: 'asyncCall.polyfill',
						detail: {
							method,
							parameters,
							response: responseArray
						}
					});
					callback(responseArray);
				}, 0);
			} else {
				callback([null, `{"code":1168,"description":"ERROR_NOT_FOUND:no handler for: ${method}"}\n`]);
				logger.warn({
					code: 'CLIENT',
					origin: 'asyncCall polyfill',
					detail: {
						code: 1168,
						description: `ERROR_NOT_FOUND:no handler for: ${method}"}\n`
					}
				});
			}
		} else {
			throw new Error('Invalid method arguments');
		}
	};
}

/**
 * Asynchronous call to client
 * @param {string} method
 * @param {Function} callback
 * @param {Array|object} [parameters]
 */
export default function asyncCall(method, callback, parameters) {
	if (typeof method === 'string' && typeof callback === 'function' && (typeof parameters === 'undefined' || typeof parameters === 'object' && parameters)) {
		window.app.asyncCall(method, (response) => {
			const error = response[1];
			const object = 'asyncCall';
			if (error && /code/.test(error) && typeof window.dispatchEvent === 'function') {
				const detail = {
					object,
					method,
					parameters,
					error
				};
				const customEvent = new CustomEvent(object, {
					detail
				});
				logger.warn({
					code: 'CLIENT',
					origin: 'asyncCall',
					detail
				});
				window.dispatchEvent(customEvent);
			}
			appDebug(`asyncCall ${method}`, {
				code: 'CLIENT',
				origin: 'asyncCall',
				detail: {
					method,
					parameters,
					response
				}
			});
			callback(response);
		}, parameters);
	} else {
		throw appError('Invalid method arguments to asyncCall', {
			code: 'APP_FRONTEND_UTIL',
			origin: 'asyncCall',
			detail: readArguments(arguments) // @todo update detail structure
		});
	}
}
